import React, { Fragment, useState, useEffect } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Container, Row, Col, Card, CardHeader, CardBody, FormGroup, Table } from 'reactstrap';
import axios from 'axios';
import config from '../../../../config';
import { Btn, Spinner } from '../../../../AbstractElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import ReactPaginate from 'react-paginate';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from "xlsx";

const HealthCheckup = () => {

    if (localStorage.getItem("usertype") !== "Backend User") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const token = localStorage.getItem("sessiontoken");


    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    const [tooltip, setTooltip] = useState('');
    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [properties, setProperties] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [status, setStatus] = useState('');
    const [reportData, setreportData] = useState([]);
    const [filteredReportData, setFilteredReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false)
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        setLoading(true)
        axios
            .post(`${config.hostname}/reports/gethealthcheckup`, { concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setreportData(response.data);
                setFilteredReportData(response.data);
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
                setLoading(false)
            });
    }, []);

    const handlePropertyChange = (e) => {
        const selectedId = e.target.value;
        setPropertyId(selectedId);

        let filtered = [...reportData];

        if (selectedId) {
            const selectedProperty = properties.find((p) => p._id === selectedId);
            if (selectedProperty) {
                filtered = filtered.filter(
                    (item) => item.property_name === selectedProperty.property_name
                );
            }
        }

        // also apply status filter if selected
        if (status) {
            if (status === "active") {
                filtered = filtered.filter((item) => item.total_missing_dates === 0);
            } else if (status === "missing") {
                filtered = filtered.filter(
                    (item) => item.total_missing_dates > 0 && item.total_missing_dates <= 30
                );
            } else if (status === "inactive") {
                filtered = filtered.filter((item) => item.total_missing_dates > 30);
            }
        }

        setFilteredReportData(filtered);
    };


    const handleStatusChange = (e) => {
        const selectedStatus = e.target.value;
        setStatus(selectedStatus);

        let filtered = [...reportData];

        // apply property filter if selected
        if (property_id) {
            const selectedProperty = properties.find((p) => p._id === property_id);
            if (selectedProperty) {
                filtered = filtered.filter(
                    (item) => item.property_name === selectedProperty.property_name
                );
            }
        }

        // apply status filter
        if (selectedStatus) {
            if (selectedStatus === "active") {
                filtered = filtered.filter((item) => item.total_missing_dates === 0);
            } else if (selectedStatus === "missing") {
                filtered = filtered.filter(
                    (item) => item.total_missing_dates > 0 && item.total_missing_dates <= 30
                );
            } else if (selectedStatus === "inactive") {
                filtered = filtered.filter((item) => item.total_missing_dates > 30);
            }
        }

        setFilteredReportData(filtered);
    };


    const handleExport = () => {
        const exportData = filteredReportData.map(item => ({
            "Tenant Name": item.tenant_name,
            "Group Name": item.group_name,
            "Property": item.property_name,
            "Tenant Code": item.tenant_code,
            "Unit Code": item.outlet_code,
            "Total Live Days": item.total_live_days,
            "Total Missing Days": item.total_missing_dates,
            "Recently Active": item.recently_active_date
                ? new Date(item.recently_active_date).toLocaleDateString()
                : ""
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Health Checkup");

        // 👉 directly download file
        XLSX.writeFile(wb, `LiveHealthCheckup_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const sortedreportData = React.useMemo(() => {
        let sortableData = [...filteredReportData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [filteredReportData, sortConfig]);

    const itemsPerPage = 50
    const pageCount = Math.ceil(filteredReportData.length / itemsPerPage);
    const currentPageData = sortedreportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };



    return (
        <Fragment>
            <Breadcrumbs parent="Admin Settings" title="Live Health Checkup" mainTitle="Live Health Checkup" />
            <Container fluid={true}>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    {/* <Label htmlFor="property_id">Property</Label> */}
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">Select Property</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    {/* <Label htmlFor="property_id">Status</Label> */}
                                    <select name="status" id="status" className="form-control"
                                        value={status} onChange={handleStatusChange}>
                                        <option value="">Select Status</option>
                                        <option value="active">Active</option>
                                        <option value="missing">Missing</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('excel'),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>
                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        {loading === true ? (
                            <div className="loader-box">
                                <Spinner attrSpinner={{ className: 'loader-3' }} />
                            </div>

                        ) : (
                            <Col sm="12" lg="12" xl="12">
                                <div className="table-responsive">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th scope="col" onClick={() => requestSort('tenant_name')}>Tenant Name {getSortIcon('tenant_name')}</th>
                                                <th scope="col" onClick={() => requestSort('group_name')}>Group Name {getSortIcon('group_name')}</th>
                                                <th scope="col" onClick={() => requestSort('property_name')}>Property {getSortIcon('property_name')}</th>
                                                <th scope="col" onClick={() => requestSort('tenant_code')}>Tenant Code {getSortIcon('tenant_code')}</th>
                                                <th scope="col" onClick={() => requestSort('outlet_code')}>Unit Code {getSortIcon('outlet_code')}</th>
                                                <th scope="col" onClick={() => requestSort('total_live_days')}>Total Live Days {getSortIcon('total_live_days')}</th>
                                                <th scope="col" onClick={() => requestSort('total_missing_dates')}>Total Missing Days {getSortIcon('total_missing_dates')}</th>
                                                <th scope="col" onClick={() => requestSort('recently_active_date')}>Recently Active {getSortIcon('recently_active_date')}</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {currentPageData.map((item, index) => {
                                                let textColor = "";

                                                if (item.total_missing_dates === 0) {
                                                    textColor = "green";
                                                } else if (item.total_missing_dates > 0 && item.total_missing_dates <= 30) {
                                                    textColor = "orange";
                                                } else if (item.total_missing_dates > 30) {
                                                    textColor = "red";
                                                }

                                                return (
                                                    <tr key={index}>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.tenant_name}</td>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.group_name}</td>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.property_name}</td>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.tenant_code}</td>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.outlet_code}</td>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.total_live_days}</td>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.total_missing_dates}</td>
                                                        <td style={{ color: textColor, fontWeight: 600 }}>{item.recently_active_date}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>


                                    </Table>


                                </div>
                                {reportData.length > 50 && (
                                    <ReactPaginate
                                        previousLabel={'<<'}
                                        nextLabel={'>>'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName={'pagination'}
                                        subContainerClassName={'pages pagination'}
                                        activeClassName={'active'}
                                        pageClassName={'page-item'}
                                        pageLinkClassName={'page-link'}
                                    />
                                )}
                            </Col>
                        )}
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}

export default HealthCheckup